import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { ConversationList } from './elements/ConversationList';
import { Link } from 'react-router';
import { Loader, Pagination } from '../../../../common/elements';
import { PaginationHelpers as Page } from '../../../../../helpers';
import networkingActions from '../../../../../actions/networking/networking';

class Conversations extends Component {

    componentDidMount() {
        const { getAllConversations, location } = this.props;
        const page = location.query ? location.query.page : 1;

        getAllConversations( page );
    };

    getCurrentConversation( conversationId ) {
        const { getConversation } = this.props;

        getConversation( conversationId );
    };

    getNextConversations( page ) {
        const { getAllConversations } = this.props;

        getAllConversations( page );
        browserHistory.push( `/networking/conversations?page=${ page }` );
    }

    render() {
        const { paging, conversations, location } = this.props;

        if( !conversations || !paging) {

            return (
				<div className="row">
					<Loader />
				</div>
            );

        } else if(conversations && conversations.length === 0 && paging !== undefined) {

            return (
                <div className="col-xs-12">
                    <h5 className="h5">You have no messages at the moment.</h5>
                    <Link type="button" className="btn btn-primary btn-block" to='/'>
                        <span className="label">Home Page</span>
                        <span className="icon"><i className="fa fa-angle-right animated-right" /></span>
                    </Link>
                </div>
            );

        } else {

            const pageLocation = paging ? paging.current_page : ( location.query ? location.query.page : 1 );

            const totalPages = paging.total_pages,
                currentPage = Page.setCurrentPage( pageLocation, totalPages ),
                pagination_details = Page.getCurrentPage( currentPage, totalPages ),
                pageNumbers = Page.getPageNumbers( pagination_details );

            return (
                <div>
                    <ConversationList conversations={ conversations }/>
                    <section className="row">
                    <div className="col-xs-12">
                    {/* {
                        totalPages > 1 &&
                            <Pagination
                                currentPage={ currentPage }
                                pagination={ pagination_details }
                                pageNumbers={ pageNumbers }
                                totalPages={  totalPages }
                                onPaginationClick={ ( currentPage ) => this.getNextConversations( currentPage ) }
                            />
                    } */}
                    </div>
                    </section>
                </div>
            );
        }
    };
}

Conversations.propTypes = {
    paging: PropTypes.object, 
    conversations: PropTypes.array, 
    location: PropTypes.object
}

const mapStateToProps = ( state ) => {
    return {
        paging: state.networking.pagination,
        conversations: state.networking.conversations
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        getAllConversations: page => dispatch( networkingActions.getAllConversations( page ) ),
        getConversation: ( conversationId ) => dispatch( networkingActions.getConversation( conversationId ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Conversations );



// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/Conversations.js